import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Hyperlink } from '../../../../../../components/Hyperlink';

import { LinkedArticleType } from '../../../../legislation.types';

import styles from './linked_links.module.scss';

type Props = {
  linkedLegislation: LinkedArticleType | null;
  id: string;
  labelId?: string;
  source?: string;
};

export const LinkedLinks: FC<Props> = ({
  linkedLegislation,
  labelId,
  id,
  source,
}) => {
  if (!linkedLegislation) return null;

  return (
    <>
      {linkedLegislation[id].items.map(({ title, url, isLinked }) => (
        <span key={title} className={styles.versionLinked}>
          {labelId && <FormattedMessage id={labelId} />}{' '}
          {isLinked ? (
            <Hyperlink
              href={url}
              className={styles.link}
              data-test-id="linked-links-link"
              source={source}
            >
              {title}
            </Hyperlink>
          ) : (
            <span className={styles.noLink}>{title}</span>
          )}
        </span>
      ))}
    </>
  );
};
